import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Deliberately not lucide building-2 — that glyph is spoken for by the Company
// object, so the design system draws its own.
export const BUILDING_NODES: IconNode = [
  [
    'path',
    {
      key: 'building-0',
      d: 'M3 21H21M9 8H10M9 12H10M9 16H10M14 8H15M14 12H15M14 16H15M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21',
    },
  ],
]

export const BuildingIcon: LucideIcon = createLucideIcon(
  'building',
  BUILDING_NODES,
)
